<script lang="ts">
  import { stateLabel } from './format';

  let { state }: { state: string } = $props();
</script>

<span class:problem={state === 'ALARM' || state === 'open'} class:resolved={state === 'OK' || state === 'resolved'} class:uncertain={state === 'INSUFFICIENT_DATA'}>
  <span aria-hidden="true" class="marker"></span>{stateLabel(state)}
</span>

<style>
  span { display: inline-flex; align-items: center; gap: .45rem; font-size: .78rem; font-weight: 750; letter-spacing: .025em; text-transform: uppercase; }
  .marker { width: .55rem; height: .55rem; border-radius: 50%; background: currentColor; }
  .problem { color: var(--danger); }
  .resolved { color: var(--success); }
  .uncertain { color: var(--warning); }
</style>
